import { useEffect } from 'react'

import { NotificationService } from '@/contentComponents/global/Notification'

import useRepository from './useRepository'

/**
 * 탭이 백그라운드에 있다가 포그라운드로 돌아올 때
 * SSE 연결은 살아있지만 그 사이 놓친 알림이 있을 수 있으므로
 * messaging-api를 호출해 최신 상태로 동기화한다.
 */
const useNotificationSync = () => {
  const notificationService = useRepository(NotificationService)

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (!document.hidden) {
        // await 하지 않으므로 실패가 처리되지 않은 프로미스 거부로 남는다.
        // 백그라운드 동기화라 실패해도 화면은 그대로 두고 경고만 남긴다.
        notificationService.fetchNotifications().catch((error) => {
          console.warn('알림 목록 동기화 실패', error)
        })
        notificationService.fetchUnreadCount().catch((error) => {
          console.warn('알림 안읽음 수 동기화 실패', error)
        })
      }
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [])
}

export default useNotificationSync
